import { Cookies } from 'react-cookie'

const _COMPANY_SPECIFIC_SUBDOMAIN_NAME = 'zocksCompanySpecificSubdomain'
const _PREFERRED_AUTH_METHOD_NAME = 'zocksPreferredAuthMethod'
const _PREFERRED_AUTH_METHOD_CANDIDATE_NAME = 'zocksPreferredAuthMethodCandidate'
const _DNS_LABEL = /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/i
const cookies = new Cookies()

const getLoginAppUrl = (): string => import.meta.env.REACT_APP_LOGIN_APP_URL!

const getCookieOptions = () => ({
  path: '/',
  domain: window.location.hostname.endsWith('localhost') ? '.dev.localhost' : '.zocks.io',
})
const getCompanySpecificSubdomain = () => cookies.get(_COMPANY_SPECIFIC_SUBDOMAIN_NAME)
export const shouldUseCompanySso = (): boolean => {
  return !!getCompanySpecificSubdomain()
}

const getCurrentHostSubdomain = (): string | undefined => {
  const loginHost = new URL(getLoginAppUrl(), window.location.origin).hostname
  const baseDomain = loginHost.substring(loginHost.indexOf('.') + 1)
  const hostname = window.location.hostname
  if (hostname === loginHost || !hostname.endsWith(`.${baseDomain}`)) {
    return undefined
  }
  const subdomain = hostname.slice(0, -(baseDomain.length + 1))
  return subdomain.includes('.') ? undefined : subdomain
}

const removePreferredAuthMethod = () => {
  cookies.remove(_PREFERRED_AUTH_METHOD_NAME, getCookieOptions())
}
const removePreferredAuthMethodCandidate = () => {
  cookies.remove(_PREFERRED_AUTH_METHOD_CANDIDATE_NAME, getCookieOptions())
}

export const getLoginAppBaseUrl = () => {
  const subdomain = getCurrentHostSubdomain() ?? getCompanySpecificSubdomain()
  return subdomain && _DNS_LABEL.test(subdomain) ? getLoginAppUrl().replace('://console.', `://${subdomain}.`) : getLoginAppUrl()
}

export const handleCompanySsoLogout = () => {
  if (shouldUseCompanySso()) {
    removePreferredAuthMethod()
    removePreferredAuthMethodCandidate()
  }
}
